module.exports = __webpack_public_path__ + "teqbahn-assets/media/29.56ea86da.jpg";